<template>

  <div ref="formStep" class="form-step" data-step="2">
    <div>
      <div ref="dynamicSpeechBubble" class="dynamicspeechbubble">
        <p>{{$t('formContent.Step3form_intro1')}} {{ localFormData.firstName }}!
          <br/>{{$t('formContent.Step3form_intro2')}}
        </p>
      </div>
      <div ref="contentWrapper" class="form-step-contentwrapper">
        <a @click="$emit('previous')" class="button marginauto previousstep editname showondesktop"
           href="#"><span>{{ localFormData.firstName }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
            <g id="Gruppe_6156" data-name="Gruppe 6156" transform="translate(-1007 -229)">
              <circle id="Ellipse_29" data-name="Ellipse 29" cx="21" cy="21" r="21"
                      transform="translate(1007 229)" fill="#015672"/>
              <g id="edit" transform="translate(1015.568 237.568)">
                <path id="Pfad_27761" data-name="Pfad 27761" d="M0,0H24.864V24.864H0Z"
                      fill="none"/>
                <path id="Pfad_27762" data-name="Pfad 27762"
                      d="M7.108,7H6.072A2.072,2.072,0,0,0,4,9.072V18.4a2.072,2.072,0,0,0,2.072,2.072H15.4A2.072,2.072,0,0,0,17.468,18.4V17.36"
                      transform="translate(0.144 0.252)" fill="none" stroke="#fff"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Pfad_27763" data-name="Pfad 27763"
                      d="M20.795,6.714a2.176,2.176,0,1,0-3.077-3.077L9,12.324v3.108h3.108l8.687-8.718Z"
                      transform="translate(0.324 0.108)" fill="none" stroke="#fff"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Pfad_27764" data-name="Pfad 27764" d="M16,5l3.108,3.108"
                      transform="translate(0.576 0.18)" fill="none" stroke="#fff"
                      stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </g>
            </g>
          </svg>
        </a>
        <form @submit.prevent="submitForm">
          <div class="form-group avatar_selection">
            <swiper-container class="swipercontainer avatar-slider"
                              ref="swiperContainer"
                              :slide-to-clicked-slide="true"
                              :centered-slides="true"
                              :initialSlide="4"
                              :pagination="{
                                hideOnClick: false,
                                clickable:true
                              }"
                              :breakpoints="{
                                300:  {
                                  slidesPerView: 1,

                                  },
                                480:  {
                                  slidesPerView: 3,

                                  },
                                769:  {
                                  slidesPerView: 5,

                                  },
                              }"


                              @swiperprogress="onProgress"
                              @swiperslidechange="onSlideChange"
                              @swiperactiveindexchange="onActiveIndexChange"
                              @swiperclick="onClick"
                              @swiperafterInit="afterInit"
            >


              <swiper-slide data-avatar="Avatare-01">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-01.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
              <swiper-slide data-avatar="Avatare-02">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-02.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
              <swiper-slide data-avatar="Avatare-03">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-03.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
              <swiper-slide data-avatar="Avatare-04">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-04.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
              <swiper-slide data-avatar="Avatare-09">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-09.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
              <swiper-slide data-avatar="Avatare-05">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-05.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
              <swiper-slide data-avatar="Avatare-06">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-06.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
              <swiper-slide data-avatar="Avatare-07">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-07.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
              <swiper-slide data-avatar="Avatare-08">
                <div class="imgwrapper">
                  <div>
                    <img src="@/assets/img/avatare/Avatare-08.webp">
                  </div>
                  <img src="@/assets/img/face_shadow.png">
                </div>
              </swiper-slide>
            </swiper-container>
          </div>

          <input
              name="chosenAvatar"
              type="hidden"
              v-model="localFormData.avatar"
          />
          <div class="acceptwrapper" style="display:flex;gap:15px;justify-content: center; align-items: flex-end">

            <button
                :class="{ 'disabled': isButtonDisabled }"
                type="submit"
                class="button nextstep">
              <span>{{$t('formContent.Step3form_button')}}</span><img src="@/assets/img/arrow-right.svg"/>
            </button>
            <a @click="$emit('previous')" class="button previousstep editname hideondesktop"
               href="#"><span>{{ localFormData.firstName }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
                <g id="Gruppe_6156" data-name="Gruppe 6156" transform="translate(-1007 -229)">
                  <circle id="Ellipse_29" data-name="Ellipse 29" cx="21" cy="21" r="21"
                          transform="translate(1007 229)" fill="#015672"/>
                  <g id="edit" transform="translate(1015.568 237.568)">
                    <path id="Pfad_27761" data-name="Pfad 27761" d="M0,0H24.864V24.864H0Z"
                          fill="none"/>
                    <path id="Pfad_27762" data-name="Pfad 27762"
                          d="M7.108,7H6.072A2.072,2.072,0,0,0,4,9.072V18.4a2.072,2.072,0,0,0,2.072,2.072H15.4A2.072,2.072,0,0,0,17.468,18.4V17.36"
                          transform="translate(0.144 0.252)" fill="none" stroke="#fff"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Pfad_27763" data-name="Pfad 27763"
                          d="M20.795,6.714a2.176,2.176,0,1,0-3.077-3.077L9,12.324v3.108h3.108l8.687-8.718Z"
                          transform="translate(0.324 0.108)" fill="none" stroke="#fff"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Pfad_27764" data-name="Pfad 27764" d="M16,5l3.108,3.108"
                          transform="translate(0.576 0.18)" fill="none" stroke="#fff"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </g>
                </g>
              </svg>
            </a>

          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {register} from 'swiper/element/bundle';
import {gsap} from "gsap";

register();

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Übertragen der aus setup() stammenden reaktiven Daten
      spaceBetween: 10,
      localFormData: JSON.parse(JSON.stringify(this.formData)),
      dynamicSpeechBubble: null,
      swiperContainer: null,
      formContent: null,
      contentWrapper: null,
      formStep: null,

    };
  },
  mounted() {
    const splitTextTimeline = gsap.timeline();
    splitTextTimeline.set(this.$refs.dynamicSpeechBubble, {display: "none", autoAlpha: 0, y: -100});
    splitTextTimeline.set(this.$refs.contentWrapper, {autoAlpha: 0});
    splitTextTimeline.set(this.$refs.swiperContainer, {autoAlpha: 0});
    setTimeout(() => {

      this.initAnimations()
    }, 250);

  },
  computed: {
    isButtonDisabled() {
      return !this.localFormData.avatar || this.localFormData.avatar.length === 0;
    }
  },
  methods: {
    submitForm() {
      this.$emit('update', this.localFormData);

      this.$emit('next');
    },
    onProgress(e) {
      const [swiper, progress] = e.detail;
    },
    onSlideChange(e) {

    },
    onActiveIndexChange(swiper) {
      let activeIndex = swiper.detail[0].activeIndex;

    },
    onClick(swiper) {
      // Zugriff auf alle Slides im Swiper
      const slides = swiper.detail[0].slides;
      // Entfernen der Klasse "deine-neue-klasse" von allen Slides
      slides.forEach((slide) => {
        slide.classList.remove('chosen-avatar');
      });

      // Zugriff auf das geklickte Slide
      const clickedSlide = swiper.detail[0].clickedSlide;

      // Hinzufügen der Klasse "deine-neue-klasse" zum geklickten Slide
      if (clickedSlide) {
        clickedSlide.classList.add('chosen-avatar');
        this.localFormData.avatar = swiper.detail[0].clickedSlide.dataset.avatar;
      }
    },
    initAnimations() {
      // Stelle sicher, dass du hier die refs entsprechend ersetzt hast
      // zum Beispiel this.$refs.dynamicSpeechBubble anstatt dynamicSpeechBubble.value
      const splitTextTimeline = gsap.timeline();
      splitTextTimeline.fromTo(this.$refs.dynamicSpeechBubble, {display: "none", autoAlpha: 0, y: -100}, {
        autoAlpha: 1,
        display: "block",
        y: 0
      });
      splitTextTimeline.fromTo(this.$refs.contentWrapper, {delay: 2, autoAlpha: 0}, {autoAlpha: 1});
      splitTextTimeline.fromTo(this.$refs.swiperContainer, {delay: 2, autoAlpha: 0}, {autoAlpha: 1});
    },

    // Weitere Methoden...
  },
};
</script>

<style scoped lang="scss">
.swipercontainer {
  width: 100%;
  @media screen and (max-width:480px) {
    width:65%;
  }
}

</style>

<style lang="scss" scoped>
.form-step {
  display: flex !important;
}

.acceptwrapper {
  @media screen and (max-width:520px) {
    flex-direction: column !important;
    gap:10px !important;
    a,button {
      margin:0px;
    }
  }
}


.swiper-slide {
  text-align: center;
  cursor: pointer;
}

.imgwrapper {
  text-align: center;
  margin: auto;
  width: 100% !important;
}

.swiper-slide-active {
  .imgwrapper img {
    transform: scale(1.08);
    transition: 1s;
    @media screen and (max-width:480px) {
      transform: scale(1);
    }
  }
}

.imgwrapper img {
  width: 100% !important;
  margin: auto;
  transform: scale(0.6);
  transition: 1s;
}


</style>
